export var TopicsFilter;
(function (TopicsFilter) {
    TopicsFilter["ALL"] = "ALL";
    TopicsFilter["PENDING"] = "PENDING";
    TopicsFilter["REJECTED"] = "REJECTED";
    TopicsFilter["ARCHIVED"] = "ARCHIVED";
    TopicsFilter["FOLLOWING"] = "FOLLOWING";
})(TopicsFilter || (TopicsFilter = {}));
export var TopicsSortOrder;
(function (TopicsSortOrder) {
    TopicsSortOrder["RECENT_POSTS"] = "RECENT_POSTS";
    TopicsSortOrder["UNREAD_POSTS"] = "UNREAD_POSTS";
    TopicsSortOrder["NEWEST_TOPICS"] = "NEWEST_TOPICS";
    TopicsSortOrder["OLDEST_TOPICS"] = "OLDEST_TOPICS";
    TopicsSortOrder["MOST_REPLIES"] = "MOST_REPLIES";
    TopicsSortOrder["LEAST_REPLIES"] = "LEAST_REPLIES";
})(TopicsSortOrder || (TopicsSortOrder = {}));
export var TopicState;
(function (TopicState) {
    TopicState["ACTIVE"] = "ACTIVE";
    TopicState["PENDING"] = "PENDING";
    TopicState["REJECTED"] = "REJECTED";
    TopicState["DRAFT"] = "DRAFT";
    TopicState["ARCHIVED"] = "ARCHIVED";
    TopicState["DELETED"] = "DELETED";
})(TopicState || (TopicState = {}));
export var AdminAccess;
(function (AdminAccess) {
    AdminAccess["ALL"] = "ALL";
    AdminAccess["ROLES"] = "ROLES";
    AdminAccess["ADMINS"] = "ADMINS";
})(AdminAccess || (AdminAccess = {}));
export var ParticipantAccess;
(function (ParticipantAccess) {
    ParticipantAccess["ALL"] = "ALL";
    ParticipantAccess["SEGMENTS"] = "SEGMENTS";
    ParticipantAccess["NONE"] = "NONE";
})(ParticipantAccess || (ParticipantAccess = {}));
export var FollowLevel;
(function (FollowLevel) {
    FollowLevel["NONE"] = "NONE";
    FollowLevel["DIRECT_REPLY"] = "DIRECT_REPLY";
    FollowLevel["ALL"] = "ALL";
})(FollowLevel || (FollowLevel = {}));
export var ModalInteraction;
(function (ModalInteraction) {
    ModalInteraction["ADD"] = "ADD";
    ModalInteraction["DELETE"] = "DELETE";
    ModalInteraction["EDIT"] = "EDIT";
    ModalInteraction["CONVERT"] = "CONVERT";
})(ModalInteraction || (ModalInteraction = {}));
export var ExportNameDisplay;
(function (ExportNameDisplay) {
    ExportNameDisplay["FullName"] = "FULL_NAME";
    ExportNameDisplay["FirstNameLastInitial"] = "FIRST_NAME_LAST_INITIAL";
    ExportNameDisplay["FirstName"] = "FIRST_NAME";
    ExportNameDisplay["FirstNameId"] = "FIRST_NAME_ID";
    ExportNameDisplay["Username"] = "USERNAME";
    ExportNameDisplay["IdOnly"] = "ID_ONLY";
})(ExportNameDisplay || (ExportNameDisplay = {}));
